export default (address) =>
  Object.keys(address)
    .map((key) => address[key])
    .filter((n) => n)
    .join(', ');
